import merge from 'lodash/merge';

import { createDashHttpClient } from '@/apis/dash.http';
import { SUMMARY_INTENT_TYPES } from '@/components/VisionAi/constants';
import { env } from '@/env';

export const camelCaseHttp = createDashHttpClient(env.visionAiApiUrl, {
  camelizeKeys: true,
});
/**
 * NOTE: We only use this as the dashboard additional content response requires its
 * keys to remain unchanged. It is preferred to use the camelCaseHttp if given the
 * option
 */
export const http = createDashHttpClient(env.visionAiApiUrl);

export async function getMessages({ startTime, endTime, limit, offset, intentTypes }, config = {}) {
  return http.get(
    '/messages',
    merge(
      {
        params: {
          startTime,
          endTime,
          limit,
          offset,
          intentTypes,
        },
      },
      config,
    ),
  );
}

export async function getMessageById(id, { includeDeleted }, config = {}) {
  return http.get(
    `/messages/${id}`,
    merge(
      {
        params: {
          includeDeleted,
        },
      },
      config,
    ),
  );
}

export async function clearMessages(config = {}) {
  return camelCaseHttp.delete('/messages', config);
}

export async function updateMessage({ messageId, regeneratedId, feedback }, config = {}) {
  const requestBody = {};

  if (regeneratedId !== undefined) requestBody.regeneratedId = regeneratedId;
  if (feedback !== undefined) requestBody.feedback = feedback;
  return camelCaseHttp.patch(`/messages/${messageId}`, requestBody, config);
}

export async function createMessage(
  { conversationId, sender, message, intentType, intentQuery, actionType, requestContext },
  config = {},
) {
  const params = {
    sender,
    message,
    intentType,
    ...(intentQuery && { intentQuery }),
    ...(actionType && { actionType }),
    ...(requestContext && { requestContext }),
  };
  return camelCaseHttp.post(`conversations/${conversationId}/messages`, params, config);
}

export async function regenerateMessage({ conversationId, messageId }, config = {}) {
  return camelCaseHttp.post(
    `conversations/${conversationId}/messages/${messageId}/regenerate`,
    config,
  );
}

export async function createConversation(config = {}) {
  return camelCaseHttp.post(`/conversations`, config);
}

export async function getConversations(
  { firstMessageStartTime, firstMessageEndTime, intentTypes },
  config = {},
) {
  return camelCaseHttp.get(
    `/conversations`,
    merge(
      {
        params: {
          firstMessageStartTime,
          firstMessageEndTime,
          intentTypes,
        },
      },
      config,
    ),
  );
}

export async function getConversationMessages({ conversationId }, config = {}) {
  return http.get(`conversations/${conversationId}/messages`, config);
}

export async function updateConversation({ conversationId, name }, config = {}) {
  return camelCaseHttp.patch(`conversations/${conversationId}`, { name }, config);
}

export async function deleteConversation({ conversationId }, config = {}) {
  return camelCaseHttp.delete(`conversations/${conversationId}`, config);
}

export async function deleteSummaryMessages(config = {}) {
  const summaryIntentTypes = SUMMARY_INTENT_TYPES.join(',');
  return camelCaseHttp.delete(
    `messages`,
    {
      params: {
        intentTypes: summaryIntentTypes,
      },
    },
    config,
  );
}
